import type { ProjectCommitSnapshot } from '@/services/version-workspace';
import type { VersionPreviewSnapshot } from '../types/version-preview-types';

/**
 * 将版本 Preview 快照适配为历史预览 loader 可消费的提交快照。
 *
 * 说明：
 * 1. `useEditorGlbLoader.switchProjectModelRootSnapshot()` 是整项目历史预览切换的统一入口；
 * 2. 版本 Preview 不能新增第二套 loader 输入协议，否则资源释放、设计树刷新和失败回滚会分叉；
 * 3. adapter 把页面语义隔离在 service/controller 层，loader 继续只认识提交快照。
 *
 * @param snapshot 版本 Preview 快照。
 * @returns 历史预览 loader 可直接消费的提交快照。
 */
export function toProjectCommitSnapshot(snapshot: VersionPreviewSnapshot): ProjectCommitSnapshot {
  return {
    projectId: snapshot.projectId,
    commitId: snapshot.versionId,
    title: snapshot.title,
    branchName: snapshot.branchName,
    modelSource: snapshot.modelSource,
  };
}
